import { React, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook.js";
import './Courses.css'; 
import HTML from '../../images/courses/html360.png'
import PYTHON from '../../images/courses/python300.png';
import JAVASCRIPT from '../../images/courses/js300.png'
import SEO from '../../images/courses/seo300.png';
import SMM from '../../images/courses/socialmedia300.png';
import FUNDAMENTALS from '../../images/courses/fundamentals300.png';

function Courses () {
  const t = useTranslation();

  const {hash} = useLocation();
  const containerRef = useRef(null);
   
    useEffect(() => {
      if (!hash) return;
      
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start"});
      }     
    }, [hash]);

  return (
    <div name="courses-main" className="container" ref={containerRef}>
      <h1>OUR COURSES, <b>YOUR JOURNEY</b></h1>
      <section id="htmlcss" name="html-css-course" className="section-container" >
        <div  className="section-part">
          <img src={HTML} onClick={() => window.open("https://google.com", "_blank") } />
          <div>
            <h2>HTML & CSS</h2>
            <p>HTML and CSS are the building blocks behind every modern website you see—from hobby, gaming, business, miscellenaous pages, shopping and news portals to blogs
              and landing pages. HTML provides the structure, defining what content appears on a page, while CSS controls how that content looks, from layout and colors to 
              fonts and responsiveness. Together, they transform ideas into clear, functional, and professional digital experiences.
            </p>
            <p>
              For individuals investing on their future in our academy, understanding HTML and CSS is more than a technical skill—it’s a strategic advantage. 
              These tools allow you to create clean, trustworthy pages that communicate credibility, highlight key information, and guide users toward action. A well-structured 
              and visually polished site helps visitors focus on what matters most for their visit.
            </p>
            <p>
              Learning HTML and CSS empowers you to take control of your digital presence without relying entirely on third parties. Whether you’re customizing educational content, 
              improving user experience, or optimizing pages for performance and clarity, these skills give you the confidence to build platforms that look professional, load fast, and
              inspire trust.
            </p>
          </div>
        </div>
        <div className="section-container bottom">
          <div style={{marginLeft:"0"}}>
            <NavLink to="https://ourhtmlcourse.com" target="_blank">Login</NavLink>
            <NavLink to="/upgrade">Enroll</NavLink>
{/*             <NavLink to="/contactus">Ask Us</NavLink> */}
          </div>
        </div>
      </section>
      <section id="python" name="python-course" className="section-container lightbg">
        <div  className="section-part">
          <img src={PYTHON} onClick={() => window.open("https://google.com", "_blank")}/>
          <div>
            <h2>PYTHON</h2>
            <p>
              Python is one of the most powerful and beginner-friendly tools used today for data analysis and automation. Known for its clarity, speed, and flexibility, 
              Python helps beginners turn raw data into clear insights, automate repetitive tasks, and build practical solutions—without needing an advanced programming background.
            </p>
            <p>
              From working with datasets and creating visualizations to building scripts, APIs, and simple applications, Python has become a core skill across many industries. 
              Its vast ecosystem of libraries makes it easy to handle real-time data, charts, statistics, and machine learning models in an efficient and intuitive way, so you can 
              focus on problem-solving rather than complexity.
            </p>
            <p>
              In this academy, Python is not taught as “just coding”—it’s taught as a practical, hands-on skill. You’ll learn how to think like a developer, improve your workflow, 
              and build projects that create real value in today’s digital world.
            </p>
          </div>
        </div>
        <div className="section-container bottom">
          <div style={{marginLeft:"0"}}>
            <NavLink to="https://ourpyhtoncourse.com" target="_blank">Login</NavLink>
            <NavLink to="/upgrade">Enroll</NavLink>
          {/*<NavLink to="/contactus">Ask Us</NavLink> */}
          </div>
        </div>
      </section>
      <section id="javascript" name="javascript-course" className="section-container third ">
        <div  className="section-part">
          <img src={JAVASCRIPT} onClick={() => window.open("https://google.com", "_blank")}/>
          <div>
            <h2 >JAVASCRIPT</h2>
            <p>
              JavaScript is one of the most powerful and versatile programming languages in the modern digital world. It brings websites to life by making them interactive, dynamic, 
              and responsive — from real-time data visualizations to animated dashboards and smart user interfaces. For anyone navigating today’s online platforms, JavaScript is the invisible 
              engine working behind the scenes.
            </p>
            <p>
              Understanding JavaScript opens the door to how websites, apps, and digital tools actually function. It helps explain how content updates instantly, 
              how notifications and alerts are triggered, and how complex information is presented in a clear and intuitive way. This knowledge bridges the gap between ideas and 
              execution, empowering you to better understand and build the tools people use every day.
            </p>
            <p>
              Learning JavaScript is also an exciting step toward innovation. It strengthens logical thinking, problem-solving, and creativity — skills that apply to any digital project. 
              Whether you want to automate simple tasks, work with data, or gain confidence building interactive experiences, 
              JavaScript provides a solid foundation for growth in a tech-driven world.
            </p>
          </div>
        </div>
        <div className="section-container bottom">
          <div style={{marginLeft:"0"}}>
            <NavLink to="https://ourpyhtoncourse.com" target="_blank">Login</NavLink>
            <NavLink to="/upgrade">Enroll</NavLink>
{/*             <NavLink to="/contactus">Ask Us</NavLink> */}
          </div>
        </div>
      </section>
      <section id="seo" name="seo-course" className="section-container lightbg fourth ">
        <div  className="section-part">
          <img src={SEO} onClick={() => window.open("https://google.com", "_blank")}/>
          <div>
            <h2 >SEO</h2>
            <p>
              Search Engine Optimization (SEO) is the engine that helps great content get discovered. In a world where people research online before taking action, SEO ensures your pages, 
              resources, and expertise appear at the right moment—when your audience is actively searching. It’s not about tricks or shortcuts; it’s about building visibility, credibility,
               and consistent long-term presence.
            </p>
            <p>
              For any website, SEO is a powerful growth channel. It helps your content rank higher in search results, reach the right people, and build trust over time. 
              By combining clear structure, relevant keywords, and high-quality content, SEO turns pages and resources into reliable entry points for motivated visitors.
            </p>
            <p>
              Most importantly, SEO delivers results that accumulate. Each optimized article, landing page, or course description strengthens your digital footprint, 
              increases organic traffic, and positions your academy as a credible authority in its field. Done well, SEO doesn’t just generate clicks—it builds lasting value.
            </p>
          </div>
        </div>
        <div className="section-container bottom">
          <div style={{marginLeft:"0"}}>
            <NavLink to="https://ourpyhtoncourse.com" target="_blank">Login</NavLink>
            <NavLink to="/upgrade">Enroll</NavLink>
{/*             <NavLink to="/contactus">Ask Us</NavLink> */}
          </div>
        </div>
      </section>
      <section id="smm" name="socialmediamarketing-course" className="section-container fifth ">
        <div  className="section-part">
          <img src={SMM} onClick={() => window.open("https://google.com", "_blank")}/>
          <div>
            <h2 >SOCIAL MEDIA MARKETING</h2>
            <p>
              Social Media Marketing is one of the most effective tools organizations can use to connect, educate, and engage their audience. In today’s fast-moving digital environment, 
              social platforms are where people discover ideas, follow trends, and interact with content in real time. A strong social presence helps turn complex topics into clear, 
              accessible information that audiences can understand and apply. 
            </p>
            <p>
              Social media is more than promotion—it’s a direct communication channel. Through short-form videos, posts, live sessions, and community discussions, brands can share timely 
              updates, practical guidance, and expert perspectives while building ongoing relationships. Consistent, meaningful interaction strengthens trust, encourages curiosity,
              and keeps audiences engaged over time.
            </p>
            <p>
              When executed well, Social Media Marketing increases visibility, supports credibility, and drives long-term engagement. It helps organizations grow their community, 
              demonstrate real value, and establish a recognizable voice in their space—while keeping content dynamic, relevant, and enjoyable.
            </p>
          </div>
        </div>
        <div className="section-container bottom">
          <div style={{marginLeft:"0"}}>
            <NavLink to="https://ourpyhtoncourse.com" target="_blank">Login</NavLink>
            <NavLink to="/upgrade">Enroll</NavLink>
{/*             <NavLink to="/contactus">Ask Us</NavLink> */}
          </div>
        </div>
      </section>
      <section name="fundamentals-course" className="section-container lightbg sixth " id="fundamentals">
        <div id="fundamentals" className="section-part">
          <img src={FUNDAMENTALS} onClick={() => window.open("https://google.com", "_blank")}/>
          <div>
            <h2 >TRADING FUNDAMENTALS</h2>
            <p>
              Trading is the art of turning market movements into opportunity. By buying and selling financial assets such as stocks, currencies, commodities, or cryptocurrencies, 
              traders aim to benefit from price changes across global markets. Fast-paced, dynamic, and data-driven, trading combines strategy, analysis, and timing—making it both an 
              exciting and intellectually rewarding activity.
            </p>
            <p>
              At its core, trading is about understanding how markets behave. Prices move based on supply and demand, economic news, global events, and investor psychology. 
              Learning how to read charts, manage risk, and apply proven strategies allows traders to make informed decisions rather than relying on guesswork or emotion.
            </p>
            <p>
              In an investing academy, trading becomes a skill you can systematically develop. With the right education, tools, and mindset, anyone can learn 
              how to approach the markets with confidence, discipline, and clarity—transforming curiosity into competence and potential into performance.
            </p>
          </div>
        </div>
        <div className="section-container bottom">
          <div style={{marginLeft:"0"}}>
            <NavLink to="https://ourpyhtoncourse.com" target="_blank">Login</NavLink>
            <NavLink to="/upgrade">Enroll</NavLink>
{/*             <NavLink to="/contactus">Ask Us</NavLink> */}
          </div>
        </div>
      </section>

    </div>
  )
}

export default Courses;